// ==============================================================================
// Imports
// ==============================================================================

import React from "react";
import {Input} from "semantic-ui-react";
import "./TableSearch.scss";

/**
 * Custom Wrapper of the Input element used for the global search feature on
 * the list pages.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
// ==============================================================================
// Table Search Component
// ==============================================================================

const TableSearch = props => {
    const { handleSearch } = props;

    return (
        <div className={"table-search-container"}>
            <div className={"search-bar"}>
                <Input
                    fluid
                    icon={"search"}
                    iconPosition={"left"}
                    onChange={handleSearch}
                />
            </div>
        </div>
    );
};

export default TableSearch;
